const dfy_menu=[
    [//0
         "  WebGL电法仪  ",
         "欢迎您使用本仪器",
        "     2022.6    ",
        " jansir@163.com",
        " 华北水利水电大学 ",
        "地球科学与工程学院"
    ],
	[//1
		"1.设置工作参数",
        "2.测量",
        "3.测线表",
        "4.显示曲线",
        "5.显示数据",
        "6.RS232通讯",
        "7.硬件测试"
    ],
	[//2
		"电阻率与激电",
        "电阻率与自电",
        "高密度与电阻率Ⅰ",
        "高密度与电阻率Ⅱ"
    ],
    [//3
        "清除测线数据",
        "清除全部数据"
    ],
    [//4
         "存储",
         "此功能未完成"
    ],
    [//5
        "1.工作测线与装置",
        "2.供电与采样参数",
        "3.增量参数"
    ],
    [//6
        "1.自电Sp",
        "2.电阻率与自电",
        "3.电池电压",
        "4.计算器",
        "5.输入极距常数",
        "6.接地电阻"
    ],
    [//7
        "1.测试键盘",
        "2.测试存储器",
        "3.测试电压放大器",
        "4.测试电流放大器",
        "5.测试A/D",
        "6.测试D/ A",
        "测试供电",
        "测试电极相"
    ],
    [//8
        "工作测线与装置",
        "",
        "输入测线号:",
        "输入测点号:",
        "",
        "确认-执行操作",
        "退出-取消操作"
    ],
    [//9
        "1.四极电测深",
        "2.联合电测深",
        "3.四极动源剖面",
        "4.联合剖面",
        "5.矩形",
        "6.偶极-偶极",
        "7.地井电法",
        "8.送K值",
        "9.五极纵轴测深"
    ],
    [//10
        "供电时间(s)：",
        "断电延时(ms)：200",
        "二次场放大量：O"
    ],
    [//11
        "测点号增量：___",
        "极距常数号增量：__",
        "曲线参数：--",
        "按+/-键切换参数",
        "按确认键下一项参数"
    ],
    [//12
        "正在测量，请等候..."
    ],
    [//13
        "正在测量，请等候...",
        "自电SP = -0.168mv"
    ],
    [//14
        "测线号：100",
        "测点号：20",
        "SP=12.35mv",
        "Ro=124.35 OHM.M",
        "VP=10.96mv",
        "IP=57.39ma",
        "M1=3.20% M4=1.67%",
        "M2=2.76% M5=1.26%",
        "按+/-键翻页"
    ],
    [//15
        "M3=2.09% M6=0.95%",
        "M7=0.34%",
        "TH=2350.0 ms",
        "D=0.83"
    ],
    [//16
        "存储测点数据",
        "",
        "测线号：100",
        "测点号：30",
        "",
        "确认 - 执行操作",
        "退出 - 取消操作"
    ],
    [//17
        "正在测量，请等候...",
        "电池电压 = 11925.0mv"
    ],
    [//18
        "Sin(x) = ****",
        "Cos(x) = ****",
        "Tg(x) = ****",
        "Ctg(x) = ****",
        "x.x = ****",
        "SQRT(x) = ****",
        "EXP(x) = ****",
        "LN(x) = ****",
        "x=**** Y=****"
    ],
    [//19
        "极距常数号："
    ],
    [//20
        "接地电阻：0.53K"
    ],
    [//21
        "测线号：点数：装置：",
        "",
        "10      15      1",
        "100     23      4",
        "-1      0       1",
        "-1      0       1",
        "-1      0       1",
        "-1      0       1",
        "-1      0       1"
    ],
    [//22
        " 显示测线曲线",
        "",
        "输入测线号：",
        "输入测点号：",
        "",
        "确认-执行操作",
        "退出-取消操作"
    ],
    [//23
        "Ro=124.35 NL=100",
        "ND= 30",
        "曲线暂时未能显示"
    ],
    [//24
        " 显示数据菜单",
        "",
        "输入测线号：",
        "输入测点号：",
        "",
        "确认-执行操作",
        "退出-取消操作"
    ],
    [//25
        "测线号: 100",
        "测点号: 20",
        "SP=12.35mV",
        "Ro=124.35 OHM.M",
        "VP=10.96mV",
        "IP=57.39mA",
        "M1=3.20% M4=1.67%",
        "M2=2.76% M5=1.26%",
        "按+/-键翻页"
    ],
    [//26
        "M3=2.09% M6=0.95%",
        "M7=0.34%",
        "TH=2350.0 ms",
        "D=0.83"
    ],
    [//27
        "正在联络，",
        "      请等待...",
        "(此功能不存在)",
        "按确认退出"
    ],
    [//28
       "1.测试键盘",
       "2.测试存储器",
       "3.测试电压放大器",
       "4.测试电流放大器",
       "5.测试A/D",
       "6.测试D/A",
       "7.测试供电",
       "8.测试电极箱",
       "此菜单功能不提供"
    ]

    
];

export {dfy_menu};